module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/b0105-kekka-upload/kekka-upload.component.css
// module id = ./src/app/b0105-kekka-upload/kekka-upload.component.css
// module chunks = main